let language = {
    RANDOM_DESIGN_EDITER_INFO_VALIDATE_TITLE: "Validation error",
    RANDOM_DESIGN_EDITER_INFO_VALIDATE_TITLE_CONTENT_1: "The total number of cards must equal the total Cards in Pack and all quantities must be non-negative.",
    RANDOM_DESIGN_EDITER_INFO_VALIDATE_TITLE_CONTENT_2: "The probability values must be between 0 and 100.",
    RANDOM_DESIGN_EDITER_INFO_VALIDATE_TITLE_CONTENT_3: "Please complete all gallery configuration: select a gallery and set the probability, and the gallery must upload at least one image.",

}
export { language }